/* eslint-disable no-nested-ternary */
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import { Popover, Spin, Table } from 'antd';
import Helpers from '@Apis/helpers';
import './style.scss';

/**
 *
 */
function MetricOpenStockTransfers({
  data, loading, tenantIds,
}) {
  const getTotalLog = (record) => {
    const val = (Number(record?.not_received_st_count) > 0 ? Math.log(Number(record?.not_received_st_count)) : 0) + (Number(record?.partially_received_st_count) > 0 ? Math.log(Number(record?.partially_received_st_count)) : 0);
    return val;
  };
  const columns = [
    {
      title: 'Location',
      render: (text, record) => <H3Text text={record?.tenant_name?.trim()?.length > 10 ? `${record?.tenant_name.trim()?.substring(0, 10)}..` : record?.tenant_name} className="" />,
    },
    {
      title: 'Transfers',
      render: (text, record) => <H3Text text={Number(record?.not_received_st_count) + Number(record?.partially_received_st_count)} className="" />,
    },
    {
      title: '',
      width: '100px',
      render: (text, record) => (
        <div className="metric-inv__expiry_split__bar" style={{ height: '8px' }}>
          <Popover title={(
            <div className="metric-inv__expiry_split__bar-info">
              <H3Text text={`${record?.partially_received_st_count} Transfers`} className="metric-inv__expiry_split__bar-info-value" />
              <div style={{ display: 'flex' }}>
                <H3Text text="Partially Received" className="metric-inv__expiry_split__bar-info-text" />
                <div style={{
                  marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                }}
                >
                  <Link to={Helpers.appendSystemDefaultFilterIdInURL(`/inventory/stock-transfer?tenant=${record?.tenant_id}&status=ISSUED&receiving_status=PARTIALLY_RECEIVED&page=1&limit=10`)} target="_blank">view</Link>
                </div>
              </div>
            </div>
          )}
          >
            <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${((((Number(record?.partially_received_st_count) > 0 ? Math.log(Number(record?.partially_received_st_count)) : 0) / getTotalLog(record)) || 0) * 100)}%`, backgroundColor: 'rgb(245,210,47)' }} />
          </Popover>
          <Popover title={(
            <div className="metric-inv__expiry_split__bar-info">
              <H3Text text={`${record?.not_received_st_count} Transfers`} className="metric-inv__expiry_split__bar-info-value" />
              <div style={{ display: 'flex' }}>
                <H3Text text="Not Received" className="metric-inv__expiry_split__bar-info-text" />
                <div style={{
                  marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                }}
                >
                  <Link to={Helpers.appendSystemDefaultFilterIdInURL(`/inventory/stock-transfer?tenant=${record?.tenant_id}&status=ISSUED&receiving_status=NOT_RECEIVED&page=1&limit=10`)} target="_blank">view</Link>
                </div>
              </div>
            </div>
          )}
          >
            <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${((((Number(record?.not_received_st_count) > 0 ? Math.log(Number(record?.not_received_st_count)) : 0) / getTotalLog(record)) || 0) * 100)}%`, backgroundColor: 'rgb(255, 86, 48)' }} />
          </Popover>
        </div>
      ),
    },
  ];

  const getTenantSplit = () => {
    let notReceived = 0;
    let partaillyReceived = 0;
    let total = 0;
    for (let i = 0; i < data?.length; i++) {
      notReceived += Number(data[i]?.not_received_st_count);
      partaillyReceived += Number(data[i]?.partially_received_st_count);
      total += (Number(data[i]?.not_received_st_count) + Number(data[i]?.partially_received_st_count));
    }
    return {
      notReceived,
      partaillyReceived,
      total,
    };
  };

  return (
    <div className="metric-inv__expiry_split__wrapper">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-inv__open-stock-transfers">
        <H3Text text="Open Stock Transfers" className="metric-inv__expiry_split__title" />
        <div className="metric-inv__expiry_split__details">
          <H3Text text={getTenantSplit()?.total} className="metric-inv__expiry_split__value" />
        </div>
        <div className="metric-inv__expiry_split__bar" style={{ marginTop: '20px', marginBottom: '10px', height: '10px' }}>
          <Popover
            title={(
              <div className="metric-inv__expiry_split__bar-info">
                <H3Text text={getTenantSplit()?.partaillyReceived} className="metric-inv__expiry_split__bar-info-value" />
                <div style={{ display: 'flex' }}>
                  <H3Text text="Partially Received" className="metric-inv__expiry_split__bar-info-count" />
                  <div style={{ marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7' }}>
                    <Link to={Helpers.appendSystemDefaultFilterIdInURL(`/inventory/stock-transfer?tenant=${tenantIds}&status=ISSUED&receiving_status=PARTIALLY_RECEIVED&page=1&limit=10`)} target="_blank">view</Link>
                  </div>
                </div>
              </div>
            )}
            placement="bottom"
          >
            <div className="metric-inv__expiry_split__bar-near-expiry" style={{ width: `${(((getTenantSplit()?.partaillyReceived / getTenantSplit()?.total) || 0) * 100)}%`, backgroundColor: data?.currentColor }} />
          </Popover>
          <Popover
            title={(
              <div className="metric-inv__expiry_split__bar-info">
                <H3Text text={getTenantSplit()?.notReceived} className="metric-inv__expiry_split__bar-info-value" />
                <div style={{ display: 'flex' }}>
                  <H3Text text="Not Received" className="metric-inv__expiry_split__bar-info-count" />
                  <div style={{ marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7' }}>
                    <Link to={Helpers.appendSystemDefaultFilterIdInURL(`/inventory/stock-transfer?tenant=${tenantIds}&status=ISSUED&receiving_status=NOT_RECEIVED&page=1&limit=10`)} target="_blank">view</Link>
                  </div>
                </div>
              </div>
            )}
            placement="bottom"
          >
            <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${(((getTenantSplit()?.notReceived / getTenantSplit()?.total) || 0) * 100)}%`, backgroundColor: data?.currentColor }} />
          </Popover>
        </div>
        <div className="metric-inv__active-split-table">
          <Table
            showHeader
            size="small"
            scroll="scroll"
            columns={columns}
            dataSource={data || []}
            pagination={data?.length > 2 ? {
              pageSize: 2,
            } : false}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
});

MetricOpenStockTransfers.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
  tenantIds: PropTypes.any,
  loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricOpenStockTransfers));
